import React, { useEffect } from "react";
import WebFont from "webfontloader";
import { BrowserRouter } from "react-router-dom";
import { ThemeProvider } from "@mui/material/styles";
import { theme } from "./utils/theme";
import { store, persistor } from "./redux/store";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { GoogleOAuthProvider } from '@react-oauth/google';

import Router from "./Router";
import { ToastProvider } from "./provider/ToastProvider";
import { LoadingProvider } from "./provider/LoadingProvider";
import { setupInterceptors } from "./utils/axiosInstance";
import { TenantProvider } from "./provider/TenantProvider";

function App() {
  useEffect(() => {
    WebFont.load({
      google: {
        families: ["Mulish:200,300,400,500,600,700,800,900"],
      },
    });
  }, []);
  setupInterceptors(store)
  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        {/* <ThemeProvider theme={theme}> */}
        <TenantProvider>
          <ToastProvider>
            <LoadingProvider>
              <BrowserRouter>
                <GoogleOAuthProvider
                  clientId={process.env.REACT_APP_GG_APP_ID || ''}
                >
                  <Router />
                </GoogleOAuthProvider>
              </BrowserRouter>
            </LoadingProvider>
          </ToastProvider>
        </TenantProvider>
        {/* </ThemeProvider> */}
      </PersistGate>
    </Provider>
  );
}

export default App;
